<script lang="ts" setup>
/* eslint-disable vue/no-lone-template */

export interface RichEditorProps {
    data: {
        html: string
    }
}
const props = defineProps<RichEditorProps>()
const attrs = useAttrs()

</script>
<template>
  <Typo
    class="mb-5"
    v-bind="attrs"
  >
    <!-- eslint-disable vue/no-v-html -->
    <div v-html="$formatTableHtml(props.data.html)" />
  </Typo>
</template>
